// Copyright (c) 2024 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
import Axios from 'axios';
import { AquaVIUserDTO } from '@shared/models/aqua-api';

// Main service class to interact with Aqua-API via portal-api.
@injectable()
export default class AquaService {
  static diToken = Symbol('aqua-service');
  protected urlPrefix = 'aqua';	// root path to portal-api endpoints for Aqua.

  // Send request to sync an order with data from Aqua.
  async syncOrder(orderName: string): Promise<string | undefined> {
    const url = `${this.urlPrefix }/sync?orderName=${encodeURIComponent(orderName)}`;
    console.log("*** SyncOrder for :", orderName, ", endpoint: ", url);

    const { data } = await Axios.get(url);

    // Return reponse to caller.
    return data;
  }

  // Get Aqua dataset for VI user.  The dataset includes workspace (projects, ...), roles, permissions, etc.
  async getVIUserData(): Promise<AquaVIUserDTO> {
    const url = `${this.urlPrefix}/projects`;
    console.log("*** getVIUserData, endpoint: ", url);

    const { data } = await Axios.get<AquaVIUserDTO>(url);

    return data;
  }
}